import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { CoreButtonStyle } from '@core-modules/components/core-button/core-button.component';
import { ModalController } from '@ionic/angular';
import { CoreListModalItem } from './core-list-modal.item';

@Component({
    selector: 'core-list-modal-page',
    templateUrl: 'core-list-modal.modal-page.html',
    styleUrls: [ 'core-list-modal.modal-page.scss' ],
})
export class CoreListModalPage
{

    //#region Constructor

    constructor
        (
            public el: ElementRef,
            private modalController: ModalController
        )
    {
        this.options = [];
    }

    //#endregion


    //#region Properties

    /**
     * height to be set on modal content
     */
    public contentHeight: string = "";

    /**
     * Title to show on top of the modal
     */
    @Input('modal-title')
    public modalTitle: string;

    /**
     * Dismiss button text
     */
    @Input('dismiss-button-text')
    public dismissButtonText: string;

    /**
     * Template of the item to render
     */
    @Input('item-template')
    public itemTemplate;

    /**
     * Input for options data
     */
    @Input()
    public options: CoreListModalItem[]

    /**
     * Animation state 
     */
    public animationState: string;

    //#endregion


    //#region Methods


    //#region Search Methods

    //#endregion

    /**
     * Item selected event handler
     * @param item 
     */
    public selectItem(item: any)
    {
        this.modalController
            .dismiss
            (
                {
                    selectedItem: item
                }
            );
    }

    /**
     * Dismiss the select modal
     */
    public async dismissModal()
    {
        try
        {
            this.modalController.dismiss(null);
        } catch {

        }
    }

    //#endregion

}
